import Vue from 'vue';
import Router from 'vue-router';

Vue.use(Router);

export const Menu = [
  {
    path: '/diary',
    name: '日记',
    title: '日记',
    component: () => import('@/pages/diary')
  }, {
    path: '/bio',
    name: '自传',
    component: () => import('@/pages/bio')
  }, {
    path: '/feature',
    name: '功能',
    title: '功能',
    component: () => import('@/pages/home')
  }, {
    path: '/price',
    name: '价格',
    title: '价格',
    component: () => import('@/pages/home')
  }, {
    path: '/ever-plan',
    name: '人类故事保存计划',
    component: () => import('@/pages/ever-plan')
  }
]

const router = new Router({
  mode: 'history',
  routes: [
    {
      path: '/',
      name: '一万年日记',
      title: 'Index',
      component: () => import('../pages/index'),
      children: [
        {
          path: '/',
          redirect: '/feature'
        },
        ...Menu,
        {
          path: '/login',
          name: '登录',
          component: () => import('@/pages/login')
        }, {
          path: '/bio/:id',
          name: 'bio-detail',
          component: () => import('@/pages/bio')
        }, {
          path: '/bio/:id/edit',
          name: 'bio-detail-edit',
          component: () => import('@/pages/bio')
        }, {
          path: '/bio/new',
          name: 'bio-new',
          component: () => import('@/pages/bio')
        }, {
          path: '/dashboard',
          name: 'dashboard',
          component: () => import('@/pages/dashboard')
        }
      ]
    }, {
      path: '*',
      redirect: '/feature'
    }
  ]
});

router.beforeEach((to, from, next) => {
  if (to.path.includes('/bio') || to.path.includes('/diary')) {
    if (!localStorage.getItem('$$token')) {
      next('/login');
    }
  }
  if (to.path.includes('/ever-plan')) {
    window.scrollTo({
      top: 0,
      behavior: 'smooth'
    })
  }
  next();
});

export default router
